<a *ngIf="isClickable === true" [href]="downloadUrl" download target="_blank">
  <mat-icon class="file-icon notranslate" [svgIcon]="iconName"></mat-icon>
  <span class="lo_sensitive title">{{ metaFileLink.title | truncate: truncateSize }}</span>
</a>
<a *ngIf="isClickable === false">
  <mat-icon class="file-icon notranslate" [svgIcon]="iconName"></mat-icon>
  <span class="lo_sensitive title">{{ metaFileLink.title | truncate: truncateSize }}</span>
</a>
